import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';
import { usePwaUpdateStore } from '@/store/pwaUpdateStore';

const TOAST_ID = 'pwa-app-update';

/**
 * Shows a persistent toast while a new service worker is waiting (set by registerSW in main.jsx)
 * until the user clicks "بروزرسانی", which activates it and reloads the page.
 */
export default function PWAUpdateToast() {
  const needRefresh = usePwaUpdateStore((s) => s.needRefresh);
  const updateSW = usePwaUpdateStore((s) => s.updateSW);

  useEffect(() => {
    if (!needRefresh || typeof updateSW !== 'function') return;
    if (toast.isActive(TOAST_ID)) return;

    toast.info(
      <div className="flex flex-col gap-3 text-right" dir="rtl">
        <p className="font-medium text-sm">نسخه جدید برنامه آماده است.</p>
        <p className="text-xs text-muted-foreground">
          برای دریافت تغییرات، دکمه زیر را بزنید.
        </p>
        <Button
          type="button"
          size="sm"
          className="w-full"
          onClick={() => {
            toast.dismiss(TOAST_ID);
            // true => send SKIP_WAITING to the waiting worker and reload once it takes control
            updateSW(true).catch(() => window.location.reload());
          }}
        >
          بروزرسانی
        </Button>
      </div>,
      {
        toastId: TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        position: 'top-center',
      }
    );
  }, [needRefresh, updateSW]);

  return null;
}
